export const UMB_LANGUAGE_ENTITY_TYPE = 'language';
export const UMB_LANGUAGE_ROOT_ENTITY_TYPE = 'language-root';

export type UmbLanguageEntityType = typeof UMB_LANGUAGE_ENTITY_TYPE;
export type UmbLanguageRootEntityType = typeof UMB_LANGUAGE_ROOT_ENTITY_TYPE;
